var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_311_48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.6666 2H5.66663C5.02331 2 4.5 2.52331 4.5 3.16663V6.16663C4.5 6.81006 5.02331 7.33337 5.66663 7.33337H10.6666C11.3101 7.33337 11.8334 6.81006 11.8334 6.16663V3.16663C11.8334 2.52331 11.3101 2 10.6666 2ZM10.6666 8.66663H5.66663C5.02331 8.66663 4.5 9.18994 4.5 9.83337V16.8334C4.5 17.4767 5.02331 18 5.66663 18H10.6666C11.3101 18 11.8334 17.4767 11.8334 16.8334V9.83337C11.8334 9.18994 11.3101 8.66663 10.6666 8.66663ZM19.3334 12.6666H14.3334C13.6899 12.6666 13.1666 13.1899 13.1666 13.8334V16.8334C13.1666 17.4767 13.6899 18 14.3334 18H19.3334C19.9767 18 20.5 17.4767 20.5 16.8334V13.8334C20.5 13.1899 19.9767 12.6666 19.3334 12.6666ZM19.3334 2H14.3334C13.6899 2 13.1666 2.52331 13.1666 3.16663V10.1666C13.1666 10.8101 13.6899 11.3334 14.3334 11.3334H19.3334C19.9767 11.3334 20.5 10.8101 20.5 10.1666V3.16663C20.5 2.52331 19.9767 2 19.3334 2Z",
    fill: "#343568"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_311_48"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.cc5801fee8bf7feccfc5b6bd92b2e609.svg";
export { ForwardRef as ReactComponent };